import React from 'react';
import { PacmanLoader, SyncLoader } from 'react-spinners';

const FullScreenLoader = ({
  bgColor = 'white-100',
  loaderType = 'pacman',
  color = '#20539F',
  text = '',
}) => {
  return (
    <div
      data-testid="alert"
      className={`fixed top-0 left-0 h-screen w-full flex items-center justify-center flex-col z-[1000] bg-${bgColor} backdrop-blur-sm`}>
      {loaderType === 'pacman' ? <PacmanLoader color={color} /> : <SyncLoader color={color} />}
      {text && (
        <p
          className="text-lg font-semibold text-blue-10 text-center mt-2"
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
    </div>
  );
};

export default FullScreenLoader;
